<template>
    <div class="col-xs-10 col-xs-offset-1">
        <div class="row">
            <div class="form-group col-xs-6">
                <label>Match Any Words</label>
                <input v-model="paramsValue" class="form-control">
            </div>
            <div class="form-group col-xs-6">
                <label>Fuzziness</label>
                <select v-model="paramsFuzziness" class="form-control">
                    <option value="0">None</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                </select>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['params'],
        name: 'SearchAnyWords',
        data () {
            return {
            }
        },
        computed: {
            paramsValue: {
                get () {
                    return this.params !== null ? this.params.value || null : null
                },
                set (newValue) {
                    this.$emit('update:params', {
                        value: newValue,
                        fuzziness: this.params.fuzziness
                    })
                }
            },
            paramsFuzziness: {
                get () {
                    return this.params !== null ? this.params.fuzziness || null : null
                },
                set (newValue) {
                    this.$emit('update:params', {
                        value: this.params.value,
                        fuzziness: newValue
                    })
                }
            }
        },
        methods: {},
        created () {
            if (this.params === null) {
                this.$emit('update:params', {
                    value: '',
                    fuzziness: 0
                })
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// SearchAnyWords.vue?78d5175d